import * as TYPES from '../types';

export const getAllOnGoingProjectAction = () => {
    return {
        type: TYPES.GET_ALL_ONGOING_PROJECT,
    };
};

export const getAllOnGoingProjectSuccessAction = (payload) => {
    return {
        type: TYPES.GET_ALL_ONGOING_PROJECT_SUCCESS,
        payload: payload
    };
};

export const getAllUpcomingProjectAction = () => {
    return {
        type: TYPES.GET_ALL_UPCOMING_PROJECT,
    };
};

export const getAllUpcomingProjectSuccessAction = (payload) => {
    return {
        type: TYPES.GET_ALL_UPCOMING_PROJECT_SUCCESS,
        payload: payload
    };
};
